<template>
  <div
    class="fixed left-0 top-0 h-screen w-screen bg-black bg-opacity-20"
  ></div>
</template>
